/* sm-home-hero-secondary — Swiper 11 (global): clickable pagination, like Manukora section-hero-secundary.js */
(function () {
  function init(section) {
    var el = section.querySelector('.sm-home-hero-secondary__swiper');
    if (!el || el.dataset.smInit || typeof Swiper === 'undefined') return;
    el.dataset.smInit = '1';
    var opts = { loop: section.dataset.loop === 'true', watchOverflow: true, autoHeight: false,
      on: { slideChangeTransitionEnd: function () { if (window.SmParallax) window.SmParallax.refresh(); } } };
    var pag = el.querySelector('.swiper-pagination');
    if (pag) opts.pagination = { el: pag, clickable: true };
    if (section.dataset.autoplay === 'true') opts.autoplay = { delay: parseInt(section.dataset.delay, 10) || 5000, disableOnInteraction: false };
    new Swiper(el, opts);
  }
  function all() { document.querySelectorAll('.sm-home-hero-secondary').forEach(init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all); else all();
  window.addEventListener('load', all);
  document.addEventListener('shopify:section:load', all);
})();
